/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const InstagramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width={40}
    height={40}
    fill="none"
    {...props}
    data-palette="InstagramIcon">
    <circle cx={14} cy={14} r={14} fill="#212933" />
    <path
      fill="#fff"
      d="M14 11.292a2.708 2.708 0 1 0 0 5.417 2.708 2.708 0 0 0 0-5.417Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.642 6.568a39.56 39.56 0 0 1 8.716 0 3.45 3.45 0 0 1 3.044 3.011 38.06 38.06 0 0 1 0 8.842 3.451 3.451 0 0 1-3.043 3.012c-2.897.32-5.82.32-8.717 0a3.451 3.451 0 0 1-3.044-3.011 38.06 38.06 0 0 1 0-8.843 3.45 3.45 0 0 1 3.044-3.01ZM18.167 9a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm-8.125 5a3.958 3.958 0 1 1 7.916 0 3.958 3.958 0 0 1-7.916 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default InstagramIcon;
